var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    color: "#115E67",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.5 15C2.5 8.125 8.125 2.5 15 2.5C16.9406 2.5 18.8545 2.95181 20.5902 3.81966C22.3259 4.68751 23.8357 5.94755 25 7.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.25 24.375C6.875 22.5 7.5 18.75 7.5 15C7.5 14.125 7.65 13.2875 7.925 12.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.6125 26.275C21.7625 25.525 22.15 23.4 22.2375 22.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15 12.5C14.337 12.5 13.7011 12.7634 13.2323 13.2322C12.7634 13.7011 12.5 14.337 12.5 15C12.5 16.275 12.375 18.1375 12.175 20",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.8125 27.5C11.075 26.675 11.375 25.85 11.525 25",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.5 16.4004C17.5 19.3754 17.5 24.3754 16.25 27.5004",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M2.5 20H2.5125",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M27.25 20C27.5 17.5 27.4137 13.3075 27.25 12.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M11.25 8.5009C12.3905 7.84244 13.6843 7.49588 15.0012 7.49609C16.3181 7.4963 17.6118 7.84327 18.7521 8.50211C19.8924 9.16094 20.8391 10.1084 21.497 11.2492C22.1549 12.39 22.5008 13.684 22.5 15.0009C22.5 15.5884 22.5 16.4634 22.475 17.5009",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginSecurity);
export default __webpack_public_path__ + "static/media/login-security.aac56e29ab11e2a2f764b9ce98bfaed1.svg";
export { ForwardRef as ReactComponent };